import React, { Component }            from 'react'
import { connect }                     from 'react-redux';
import {
    GetTipoMidiaPost,
    GetComentariosPost,
    SetComentarioPost,
    GetRemoverComentarioEquipe
} from '../../../actions/grupoAction';
import EquipeAlunoComentarioPostForm    from './equipe_aluno_comentario_post_form';
import ComentarioPost                   from '../../../container/renderComentarioPostTimelineEquipe';
import FotoPerfil                       from '../../../container/renderFotoPerfil';
import BtAcaoComentario                 from '../../../container/btAcaoRemoverItem';
import TimeLineItem                     from '../../../container/renderTimeLineEquipe';

import '../../../css/professor/style_equipe.css';

class Equipe_Aluno_Comentario_oPost extends Component {

    constructor(props) {

        super(props);
        this.state = {
            load               : false,
            loadComentario     : false,
            buttonDisabledCom  : false,
            ItemComentarioPost : [],
            comentariosPost    : [],
            equ_pos_midia      : this.props.ItemPostTimeline.equ_pos_midia,
            equ_pos_tipo       : this.props.ItemPostTimeline.equ_pos_tipo,
            equ_pos_id         : this.props.ItemPostTimeline.equ_pos_id,
            use_foto           : this.props.ItemPostTimeline.use_foto,
            use_nome           : this.props.ItemPostTimeline.use_nome,
            created_at         : this.props.ItemPostTimeline.created_at,
            equ_pos_post       : this.props.ItemPostTimeline.equ_pos_post,
            num_like           : this.props.ItemPostTimeline.num_like
        }
    }

    componentWillMount(){
   
        this.props.GetComentariosPost(this.props.ItemPostTimeline.equ_pos_id).then((response) => {
            this.setState({loadComentario: true });
        })
    }

    exclusaoComentarioPost(elem){
 
        this.props.GetRemoverComentarioEquipe(this.props.session.id,elem);
    }

    renderComentatariosPostEquipe(){
        
            const listComentarios = this.props.feth_comentarios;
            if (listComentarios.length) {

               return listComentarios.map((elem, i) => {
               return <ComentarioPost
                        id         = {elem.equ_com_pos_id}
                        foto       = {elem.use_foto}
                        nome       = {elem.use_nome}
                        key        = {i}
                        funcao     = {<BtAcaoComentario funcao={this.exclusaoComentarioPost.bind(this,elem)}/>}
                        use_id     = {this.props.session.id}
                        use_id_com = {elem.equ_com_pos_cod_usuario}
                        coment     = {elem.equ_com_pos_comentario}
                      />;
                });

            } else {

                return "";
            }
    }

    render() {
       
       const formComent = <div className="media-raking">
                                <div className="media-left">
                                    <FotoPerfil width="32" height="32" className="media-object img-rounded" src={this.props.session.foto} />
                                </div>
                                <div className="media-body">
                                    <EquipeAlunoComentarioPostForm equ_pos_id={this.state.equ_pos_id} use_id={this.props.session.id} />
                                </div>
                            </div>;

        const btAcao = <span>{formComent} <div id="comentarios">{(this.state.loadComentario ? this.renderComentatariosPostEquipe() : "")}</div></span>;
        return (
            <div>
                <ul className="timeline bottom-zero">
                  <TimeLineItem
                        id           = {this.state.equ_pos_id}
                        foto         = {this.state.use_foto}
                        nome         = {this.state.use_nome}
                        dataCriado   = {this.state.created_at}
                        postConteudo = {this.state.equ_pos_post}
                        midia        = {this.state.equ_pos_midia}
                        tipo         = {this.state.equ_pos_tipo}
                        postMidia    = {<div dangerouslySetInnerHTML={{__html: this.props.GetTipoMidiaPost(this.props.ItemPostTimeline)}} />}
                        footerPost   = { btAcao }
                    />
               </ul>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        session          : state.auth.session,
        feth_comentarios : state.equipeReducer.all_comentarios_posts_equipe
    }
}

export default connect(mapStateToProps, { GetTipoMidiaPost, GetComentariosPost, SetComentarioPost, GetRemoverComentarioEquipe })(Equipe_Aluno_Comentario_oPost);



// WEBPACK FOOTER //
// ./src/components/professor/timeline_equipe/equipe_aluno_comentario_post.js